import { encode as base64_encode } from "base-64";

import { postApi, baseURL } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";

class VehicleAuditSore {
  loading = false;
  total = 0;
  auditList = [];
  vehicleArr = [];
  driverArr = [];
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      loading: observable,
      total: observable,
      auditList: observable,
      vehicleArr: observable,
      driverArr: observable,

      loadData: action,
      deleteRecord: action,
      addData: action,
      exportExcel: action,
      getVehicleData: action,
      getDriverData: action,
      getVehAuditData: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ companyId, offset, limit, page }) {
    this.loading = true;
    var postData = {
      companyId: companyId,
      offset: offset,
      limit: limit,
      page: page,
    };

    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=vehicle&a=getVehicleAudit", "postData=" + base64Input);
    var response = await postApi
      .getClient()
      .get(config.NodeUrl + "/vehicleaudit/getVehicleAudit", {
        params: postData,
      });

    this.auditList = response?.data?.data;
    this.total = parseInt(response?.data?.data?.TotalCount);

    this.loading = false;
  }

  async addData(vehAuditDetails) {
    var postData = vehAuditDetails;
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=vehicle&a=updateAudit", "postData=" + base64Input);
    var response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/vehicleaudit/saveVehicleaudit", { postData });

    return response.data;
  }

  async getVehAuditData({ Id, companyId }) {
    var postData = {
      Id: Id,
      companyId: companyId,
      limit: 1,
      offset: 0,
    };
    // console.log(postData)

    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=vehicle&a=getVehicleAudit", "postData=" + base64Input);
    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/vehicleaudit/getVehicleAudit", {
        params: postData,
      });
    return response?.data?.data[0];
  }

  async deleteRecord({ Id }) {
    const postData = {
      Id: Id,
    };

    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=vehicle&a=removevehicleAudit",
    //     "postData=" + base64Input
    //   );
    var response = await postApi
      .getClient("")
      .delete(config.NodeUrl + "/vehicleaudit/deleteVehicleaudit", {
        params: {
          Id: Id,
        },
      });
    return response;
  }

  async exportExcel(getData) {
    try {
      var response = await postApi
        .getClient("")
        .post(
          config.NodeUrl + "/vehicleaudit/exportVehicleAuditExcel",
          getData,
          {
            responseType: "blob",
          },
        );

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Vehicle audit Report.xlsx";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file", error);
    }
  }

  async getVehicleData(companyId) {
    var postData = {
      companyId: companyId,
    };

    if (config.pythonReport == 1) {
      var response = await postApi
        .getClient("")
        .get(config.NodeUrl + "/vehicle/getAllVehicles", {
          params: postData,
        });
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post(
          "index.php?c=vehicle&a=getvehicleDetails",
          "postData=" + base64Input,
        );
    }

    this.vehicleArr = response.data.data;
  }

  async getDriverData(companyId) {
    var postData = {
      companyId: companyId,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/driver/getDriverData", { params: postData });
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=driver&a=getDriver", "postData=" + base64Input);
    this.driverArr = response.data.data;
  }
}

export default VehicleAuditSore;
